import {analytics} from "./firebase";
import {logEvent} from "firebase/analytics";

export default async function logCustomAnalyticsEvent(analyticsEventName, payload) {
    logEvent(analytics, analyticsEventName, payload);
}
